import classNames from 'classnames';

const MMID = ({ className }: { className?: string }) => {
    // todo: fetch `${process.env.GATSBY_EHMP_URL}mcws/rs/app-setting/v2` at build time. (currently blocked by 403 error)
    return (
        <p className={classNames(className)}>
            Last Updated Date: 9/20/2023 | MULTIPLAN_EHI_2023_379_M
        </p>
    );
};

export default MMID;
